import React, { useState, useEffect } from 'react';
import '../../src/assets/css/style.css';
import footer from "../../src/assets/img/mainfooterbg.png"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getApplicantCertificateCheck } from "../CertificateService"
import { Link, useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import Modal from 'react-modal';
import Navbar from "./Navbar";
import { postNumberVerification, postOtpVerification, } from "../CertificateService";

const CertificateCheck = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    console.log(params.get('evnt_index'), "papapa")
    console.log([...params])
    const handleCloseDelete = () => setShowDelete(false);
    const [showDelete, setShowDelete] = useState(false);
    const [achievementList, setAchievementList] = useState([]);
    const [integerValue, setIntegerValue] = useState(null);
    const [blockList, setBlockList] = useState();
    const [userData, setUserData] = useState(null);
    const [remark, setRemark] = useState("");
    const [applicantId, setApplicantId] = useState(null);

    const [mobileNumber, setMobileNumber] = useState();
    const [isValidMobile, setIsValidMobile] = useState(true);
    // const [otp, setOtp] = useState();
    const [isValidOtp, setIsValidOtp] = useState(true);
    const [sendOtp, setSendOtp] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [resendTimer, setResendTimer] = useState(30);

    const [certificateDataList, setCertificateDataList] = useState();

    const [otp, setOtp] = useState(); // State to store OTP input
    const [generatedOtp, setGeneratedOtp] = useState(null); // State to store generated OTP
    const [isOtpVerified, setIsOtpVerified] = useState(false); // State for success message
    const [errorMessage, setErrorMessage] = useState(""); // State for error message
    const [timer, setTimer] = useState(0); // State for timer

    const [isChecked, setIsChecked] = useState(false); // State for success message

    console.log(certificateDataList, "certificateDataList")

    useEffect(() => {
        const jsonString = localStorage.getItem("Certificate_user");
        console.log(jsonString, "string")
        const data = JSON.parse(jsonString);
        setUserData(data);
    }, []);


    const onVerify = () => {

        console.log("verifyyyyyyyyyyyyyy")
        if (!otp) {
            toast.error("Please Type 4 digit OTP")
        } else {
            postOtpVerification(mobileNumber, otp, (res) => {
                console.log(res, "koko")
                if (res?.StatusCode == 0) {
                    const dataMobile = { "mobile": mobileNumber }
                    localStorage.setItem("Certificate_user", JSON.stringify(dataMobile));

                    toast.success("OTP Verified successfully")
                    navigate("/add-certificate");

                } else {
                    toast.error("Invalid Otp")
                }
            })

        }

    }


    const onSend = (e) => {
        if (!mobileNumber) {
            toast.error("Please Enter your mobile number")
        } else {
            postNumberVerification(mobileNumber, (res) => {
                console.log(res, "koko")
                if (res?.StatusCode == 0) {
                    toast.success("OTP has been send successfully")
                    setSendOtp(true)
                    startResendTimer();
                } else {
                    toast.error(res.message)
                }
            })


            // setSendOtp(true)
        }
    }

    const resendOtp = () => {
        onSend();
    };

    const startResendTimer = () => {
        setResendTimer(30); // Reset timer to 30 seconds
        const timerInterval = setInterval(() => {
            setResendTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(timerInterval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const onMobile = (e) => {
        const inputValue = e.target.value;

        // Only allow numbers and limit to 10 digits
        if (inputValue.length <= 10 && /^[0-9]*$/.test(inputValue)) {
            setMobileNumber(inputValue);
        }
    };


    const onApplicationId = (e) => {
        setApplicantId(e.target.value)
    }

    const onSearch = () => {
        if (!applicantId) {
            toast.error("Please enter Certificate No");
        } else {

            getApplicantCertificateCheck(applicantId).then(function (result) {
                const response = result?.data;
                setCertificateDataList(response);
            });
        }
    }

    const onCheckNext = () => {
        setApplicantId("");
        setCertificateDataList("");
    }



    return (
        <div>


            <ToastContainer />
            <div className='container-fluid'>
                <div className='dbMain businessUnit'>
                    <div className='dbRight'>
                        {/* <Navbar /> */}

                        {/* <Header link="/dashboard" breadcm="Configuration > " title="Business unit" description="There are many variations of passages of Lorem Ipsum available." /> */}
                        <div className="grid-container">
                            <div
                                className="grid-x align-center align-middle"
                                style={{
                                    height: "30vh",
                                    padding: "10px", // Add padding for better spacing on smaller screens
                                }}
                            >
                                <div className="cell small-12 medium-8 large-6">
                                    <h2
                                        className="text-center"
                                        style={{
                                            color: "#ff5722",
                                            fontSize: "22px",
                                            marginBottom: "15px",
                                            display: "flex",
                                            justifyContent: "center",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        Check Certificate Number
                                    </h2>
                                    <div
                                        className="input-group"
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <input
                                            value={applicantId}
                                            type="number"
                                            placeholder="Enter Certificate Number"
                                            style={{
                                                borderRadius: "10px",
                                                border: "2px solid #ff9800",
                                                width: "50%", // Set to half the container width
                                                padding: "10px",
                                                fontSize: "16px",
                                                marginRight: "10px", // Add spacing between input and button
                                            }}
                                            onChange={onApplicationId}
                                        />
                                        <button
                                            className="button"
                                            style={{
                                                backgroundColor: "#ff9800",
                                                borderRadius: "20px",
                                                color: "black",
                                                padding: "8px 10px",
                                                fontSize: "16px",
                                            }}
                                            onClick={onSearch}
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {certificateDataList ?
                            <div className="card">


                                {certificateDataList?.Message === "Success" ?

                                    <>
                                        <h3 className="card-title">Certificate No - {applicantId}</h3>
                                        <b style={{ color: "orange" }}>{certificateDataList?.User?.GP_NAME}-{certificateDataList?.User?.BLOCK_NAME}-{certificateDataList?.User?.DIST_NAME}</b>
                                        <div className="card-content">
                                            <div className="row">
                                                <div className="col">Applicant Name</div>
                                                <div className="col highlight">{certificateDataList?.User?.NAME_APPLI}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col">Certificate Issued by GP</div>
                                                <div className="col highlight">
                                                    {certificateDataList?.User?.CHAR_CERT === "-" ? "" : <li>{certificateDataList?.User?.CHAR_CERT}</li>}
                                                    {certificateDataList?.User?.INCM_CERT === "-" ? "" : <li>{certificateDataList?.User?.INCM_CERT}</li>}
                                                    {certificateDataList?.User?.RESI_CERT === "-" ? "" : <li>{certificateDataList?.User?.RESI_CERT}</li>}
                                                    {certificateDataList?.User?.SPER_CERT === "-" ? "" : <li>{certificateDataList?.User?.SPER_CERT}</li>}
                                                    {certificateDataList?.User?.DIST_CERT === "-" ? "" : <li>{certificateDataList?.User?.DIST_CERT}</li>}
                                                    {certificateDataList?.User?.CAST_CERT === "-" ? "" : <li>{certificateDataList?.User?.CAST_CERT}</li>}
                                                </div>

                                            </div>

                                            <div className="row">
                                                <div className="col">Status</div>
                                                <div className="col highlight">{certificateDataList?.Message === "Success" ? "Valid" : certificateDataList?.Message}</div>

                                            </div>

                                        </div>
                                    </> : <>
                                        <h3 className="card-title">Status - {certificateDataList?.Message}</h3><br></br></>
                                }
                                <button className="card-button" onClick={onCheckNext}>Check Next Application</button>
                            </div> : ""}



                    </div>
                </div>
            </div>


            <nav className="footer" >
                <img src={footer} style={{ marginTop: "350px" }} />
                <p className="text-center lastp" style={{ fontSize: "16px !important" }}><strong>©</strong>
                    2024 Designed and Developed By <b>IT And Statistical Cell,</b> Panchayat & Rural
                    Development Department <b>Govt. of West Bengal</b>
                </p>
                <p className="text-center lastp" style={{ fontSize: "14px !important" }}>Site best viewed with 1920x1080 resolution in
                    Google Chrome 31.0.1650.63, Firefox 55.0.2, Safari 5.1.7 & IE 11.0 and above</p>
            </nav>

        </div>

    )
}

export default CertificateCheck;